module.exports = __webpack_public_path__ + "img/专科2.bf050f03.jpg";